import { RouterProvider } from 'react-router-dom';
import { useEffect } from 'react';
import router from './router';
import createUuid from './helpers/uuid';

function App() {
  useEffect(() => {
    let storedCartId = localStorage.getItem('cart_id');
    if (!storedCartId) {
      storedCartId = createUuid();
      localStorage.setItem('cart_id', storedCartId);
    }
  }, []);
  return (
    <RouterProvider router={router} />
  );
}

export default App;
